module.exports = __webpack_public_path__ + "img/info_empty.56fc16c8.png";